import {
  DevHubBox,
  DevHubGrid,
  DevHubLink,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';

type Props = {
  primaryText: string;
  secondaryText: string | JSX.Element;
  link?: string;
};

/**
 * Flex box to display formatted application info
 * @param props props of the component
 * @param props.primaryText Title of the info item
 * @param props.secondaryText Value of the info item
 */
function AppInfoItem(props: Props) {
  return (
    <DevHubGrid justifyContent="space-between" alignItems="center" container>
      <DevHubGrid item>
        <DevHubBox m={1}>
          <DevHubTypography fontSize="small" weight="bold">
            {props.primaryText}
          </DevHubTypography>
        </DevHubBox>
      </DevHubGrid>
      <DevHubGrid item>
        <DevHubBox m={1}>
          <DevHubTypography fontSize="small">
            {props.link ? (
              <DevHubLink target="_blank" href={props.link}>
                {props.secondaryText}
              </DevHubLink>
            ) : (
              <>{props.secondaryText}</>
            )}
          </DevHubTypography>
        </DevHubBox>
      </DevHubGrid>
    </DevHubGrid>
  );
}

export default AppInfoItem;
